<template>
	<div class="stats-list">
		<div class="filter-bar">
			<div class="filter-item">
				<span class="filter-label">操作类型：</span>
				<el-select v-model="localActionType" placeholder="请选择" clearable @change="handleChange">
					<el-option label="全部" value=""></el-option>
					<el-option label="发布" value="publish"></el-option>
					<el-option label="下架" value="pulloff"></el-option>
					<el-option label="删除" value="delete"></el-option>
				</el-select>
			</div>
			<div class="filter-item">
				<span class="filter-label">关键词：</span>
				<el-input 
					v-model="localKeyword" 
					placeholder="搜索账号编号" 
					clearable
					@clear="handleChange"
					@keyup.enter.native="handleChange">
				</el-input>
			</div>
			<el-button type="primary" @click="handleSearch">搜索</el-button>
		</div>
		
		<el-table :data="listData" border style="width: 100%;" v-loading="loading">
			<el-table-column prop="account_no" label="账号编号" min-width="150" show-overflow-tooltip></el-table-column>
			<el-table-column prop="action_text" label="操作类型" width="100" align="center">
				<template slot-scope="scope">
					<el-tag :type="getActionTagType(scope.row.action)" size="small">{{ scope.row.action_text }}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="reason_text" label="原因" min-width="150" show-overflow-tooltip>
				<template slot-scope="scope">
					<span v-if="scope.row.reason_text">{{ scope.row.reason_text }}</span>
					<span v-else class="empty-text">-</span>
				</template>
			</el-table-column>
			<el-table-column prop="admin_nickname" label="管理员" width="120" show-overflow-tooltip></el-table-column>
			<el-table-column prop="createtime_text" label="操作时间" width="180"></el-table-column>
		</el-table>
		
		<div class="pagination-wrapper">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="localPage"
				:page-sizes="[20, 50, 100]"
				:page-size="localLimit"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	name: 'StatsList',
	props: {
		listData: {
			type: Array,
			default: () => []
		},
		total: {
			type: Number,
			default: 0
		},
		loading: {
			type: Boolean,
			default: false
		},
		actionType: {
			type: String,
			default: ''
		},
		keyword: {
			type: String,
			default: ''
		},
		page: {
			type: Number,
			default: 1
		},
		limit: {
			type: Number,
			default: 20
		}
	},
	data() {
		return {
			localActionType: this.actionType,
			localKeyword: this.keyword,
			localPage: this.page,
			localLimit: this.limit
		};
	},
	watch: {
		actionType(val) {
			this.localActionType = val;
		},
		keyword(val) {
			this.localKeyword = val;
		},
		page(val) {
			this.localPage = val;
		},
		limit(val) {
			this.localLimit = val;
		}
	},
	methods: {
		handleChange() {
			this.$emit('update:actionType', this.localActionType);
			this.$emit('update:keyword', this.localKeyword);
			this.$emit('update:page', 1);
			this.$emit('query');
		},
		handleSearch() {
			this.localPage = 1;
			this.handleChange();
		},
		handleSizeChange(val) {
			this.localLimit = val;
			this.localPage = 1;
			this.$emit('update:limit', val);
			this.$emit('update:page', 1);
			this.$emit('query');
		},
		handleCurrentChange(val) {
			this.localPage = val;
			this.$emit('update:page', val);
			this.$emit('query');
		},
		getActionTagType(action) {
			const typeMap = {
				'publish': 'success',
				'pulloff': 'warning',
				'delete': 'danger'
			};
			return typeMap[action] || 'info';
		}
	}
};
</script>

<style scoped>
.stats-list {
	padding: 20px;
}

.filter-bar {
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
	margin-bottom: 20px;
	padding: 15px 20px;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.filter-item {
	display: flex;
	align-items: center;
	gap: 8px;
}

.filter-label {
	font-size: 14px;
	color: #666;
	white-space: nowrap;
}

.filter-item .el-select {
	width: 120px;
}

.filter-item .el-input {
	width: 200px;
}

.pagination-wrapper {
	margin-top: 20px;
	display: flex;
	justify-content: flex-end;
}

.empty-text {
	color: #999;
}

:deep(.el-table) {
	font-size: 14px;
}

:deep(.el-table th) {
	background: #fafafa;
	color: #333;
	font-weight: 600;
}

:deep(.el-table td) {
	padding: 12px 0;
}

:deep(.el-tag) {
	padding: 0 8px;
	height: 24px;
	line-height: 22px;
}

@media (max-width: 768px) {
	.filter-bar {
		flex-direction: column;
	}
	
	.filter-item {
		width: 100%;
	}
	
	.filter-item .el-select,
	.filter-item .el-input {
		flex: 1;
		width: auto;
	}
}
</style>
